import { selectItemById } from '../selectors/items';
import { TYPES, ErrorMessages, SuccessMessages } from '../../common/constants';
import * as client from '../../services/client';
import { PATHS } from '../../common/constants';
import {  toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { startFormLoading, stopFormLoading, startPRLoading, stopPRLoading } from './loader';
import { setValidation } from './validation';
import { ToastFail, ToastSuccess } from '../../helpers/validationHelper';
import { onSaveItemsResponseDone } from './suites';

const fetchItemsDone = payload => ({
  type: TYPES.FETCH_ITEMS_DONE,
  payload,
});
  
export const fetchItems = () => dispatch => {
  //dispatch(startLoading())
  dispatch(startPRLoading())
  const user=JSON.parse(localStorage.getItem("user"));
  let roleName='';
  if (user && user.id){
     roleName = user.roles[0].role.name;
  }
  return client.getItems(user.id,roleName)
  .then(
    response => {
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {
           let filterData = responsejson.map(rs => {
             if(rs.properties.length > 0) {
              let names = '';
              rs.properties.map((ps, index) => {
                  return (
                    names =  names + ps.name + (rs.properties.length-1 === index ? '' : ', ')
                  )
                })
                return { ...rs, propertyNames : names}
             } else {
              return { ...rs, propertyNames : ''}
             }
            })             
          dispatch(fetchItemsDone(filterData))
          dispatch(stopPRLoading())
          //dispatch(stopLoading())
          }
        )
      }else{
        dispatch(stopPRLoading())
        // dispatch(stopLoading())
        // alert('Something Went Wrong !')
      }
    }
  );

 
};

const saveItemDone = payload => ({
  type: TYPES.SAVE_ITEM_DONE,
  payload,
});

export const saveItem = item => dispatch => {
  dispatch(startFormLoading())
  return client.saveItem(item).then(
    response =>{
      dispatch(stopFormLoading())
      if(response.ok || response.status === 200){
          response.json().then(
            responsejson => {
              dispatch(setValidation('Item'))
              toast.success( "ⓘ Item has been added.",{autoClose:12000,position:'top-center'})
             if(responsejson.data !== null){
              let names = '';
              if(responsejson.data.properties && responsejson.data.properties.length > 0) {
                responsejson.data.properties.map((ps, index) => {
                    return (
                      names =  names + ps.name + (responsejson.data.properties.length-1 === index ? '' : ', ')
                    )
                  })
               }
               dispatch(saveItemDone({...responsejson.data, propertyNames: names}))
            }}
          )
      }else{

      }
    }
  )


  // return new Promise(resolve => resolve({ data: { ...item, id: 1 }}))
  //   .then(
  //     response => dispatch(saveItemDone(response.data)),
  //   );
};


const deleteItemDone = payload => ({
  type: TYPES.DELETE_ITEM_DONE,
  payload
})
toast.configure();
export const deleteItem = (id,history) => dispatch=> {
  dispatch(startFormLoading())
  return client.deleteItem(id).then(
    response => {
      dispatch(stopFormLoading())
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {
            toast.success( ' ⓘ  Item has been deleted.',{autoClose: 12000,position:'top-center'})
            if(history){
              history.push(PATHS.ITEMS_LIST)
            }
            dispatch(deleteItemDone(id))
          }
        )
      }else{
        // alert('Something Went Wrong !')
      }
    }
  )
}

const updateItemDone = payload => ({
  type:TYPES.UPDATE_ITEM_DONE,
  payload
})

export const updateItem = (data,history) => dispatch => {
  dispatch(startFormLoading())
  return client.updateItem(data).then(
    response => {
      dispatch(stopFormLoading())
      if(response.ok || response.status === 200){
       toast.success ('ⓘ Item has been updated.',{autoClose:12000,position:'top-center'})
        if(history){
          history.push(PATHS.ITEMS_LIST)
        }
        response.json().then( responsejson => {
          dispatch(setValidation('Item'));
          let names = '';
          if(responsejson.data.properties && responsejson.data.properties.length > 0) {
            responsejson.data.properties.map((ps, index) => {
                return (
                  names =  names + ps.name + (responsejson.data.properties.length-1 === index ? '' : ', ')
                )
              })
           }
           dispatch(updateItemDone({...responsejson.data, propertyNames: names}))
        })
      }else{
        dispatch(setValidation('Item'));
        toast.error('🚫 Something Went Wrong Please retry',{autoClose:12000,position:'top-center'})
      }
    }
  )
}

const fetchItemByIdDone = payload => ({
  type: TYPES.FETCH_ITEM_BY_ID_DONE,
  payload,
});

export const fetchItemById = id => (dispatch, getState) => {
  const item = selectItemById(getState(), id);
  if (!item) {
    return client.getItemById(id)
      .then(
        response => dispatch(fetchItemByIdDone(response.data)),
      );
  }
};

const fetchItemNotesDone = payload => ({
  type: TYPES.FETCH_ITEM_NOTES_DONE,
  payload,
});

export const fetchItemNotes = (id, query) => dispatch => {
  return client.getItemNotes(id, query)
    .then(
      response => dispatch(fetchItemNotesDone({ id, notes: response.data })),
    );
};

const fetchItemDocumentsDone = payload => ({
  type: TYPES.FETCH_ITEM_DOCUMENTS_DONE,
  payload,
});

export const fetchItemDocuments = (id, query) => dispatch => {
  return client.getItemDocuments(id, query)
    .then(
      response => dispatch(fetchItemDocumentsDone({ id, documents: response.data })),
    );
};

/*
  Created By: Sai Prasad
  Created Date: 01/09/2022
  Jira Ticket: JUN-3153
  Description: function to save bulkitems.
*/

export const saveBulkImportCatalog = (params) => dispatch => {
  dispatch(startPRLoading())
  return client.addBulkCatalogs(params).then(response => {
    dispatch(stopPRLoading())
    if(response.status === 200) {
      response.json().then(responsejson => {
        if(responsejson && responsejson.statusCode === 200) {
          dispatch(fetchItems())
          dispatch(setValidation('Items Imported'));
          dispatch(onSaveItemsResponseDone(responsejson.data));
        } else {
          ToastFail(ErrorMessages.catalogImportError);
        }
      })
    } else {
      ToastFail(ErrorMessages.catalogImportError);
    }
  }).catch(() => {
    dispatch(stopPRLoading())
    ToastFail(ErrorMessages.error);
  })
}

/*
  Created By: Sai Prasad
  Created Date: 11/10/2022
  Jira Ticket: JUN-3325
  Description: function to fetch specification based on the itemId.
*/
export const fetchSpecifications = (itemId) => dispatch => {
  dispatch(startPRLoading());
  return client.fetchSpecifications(itemId).then(response => {
    dispatch(stopPRLoading());
    if(response.status === 200) {
      response.json().then(responsejson => {
        if(responsejson.statusCode === 200) {
          dispatch(onFetchSpecificationsDone(responsejson.data));
        } else {
          dispatch(onFetchSpecificationsDone([]));
        }
      })
    } else {
      dispatch(onFetchSpecificationsDone([]));
    }
  }).catch(() => {
    dispatch(stopPRLoading());
    dispatch(onFetchSpecificationsDone([]));
  })
}

export const onFetchSpecificationsDone = (data) => dispatch => {
  dispatch({
    type: TYPES.FETCH_SPECIFICATIONS_DONE,
    payload: data
  })
}

/*
  Created By: Sai Prasad
  Created Date: 11/10/2022
  Jira Ticket: JUN-3325
  Description: function to create specification to item.
*/
export const onSaveSpecification = (params) => dispatch => {
  dispatch(startFormLoading());
  return client.saveItemSpecifications(params).then(response => {
    dispatch(stopFormLoading());
    if(response.status === 200) {
      response.json().then(responsejson => {
        if(responsejson.statusCode === 200) {
          dispatch(setValidation('Specification Saved'));
          dispatch(onSaveSpecificationDone(responsejson.data));
          ToastSuccess(SuccessMessages.specificationSaved);
        } else {
          ToastFail(ErrorMessages.specificationFailed);
        }
      })
    } else {
      ToastFail(ErrorMessages.specificationFailed);
    }
  }).catch(() => {
    ToastFail(ErrorMessages.error);
    dispatch(startFormLoading());
  })
}

export const onSaveSpecificationDone = (data) => dispatch => {
  dispatch({
    type: TYPES.SPECIFICATION_SAVE_DONE,
    payload: data
  })
}

/*
  Created By: Sai Prasad
  Created Date: 12/10/2022
  Jira Ticket: JUN-3342
  Description: function to update specification to item.
*/
export const onUpdateSpecification = (params) => dispatch => {
  dispatch(startFormLoading());
  return client.updateItemSpecifications(params).then(response => {
    dispatch(stopFormLoading());
    if(response.status === 200) {
      response.json().then(responsejson => {        
        if(responsejson.statusCode === 200) {
          dispatch(setValidation('Specification Saved'));
          dispatch(onUpdateSpecificationDone(responsejson.data));
          ToastSuccess(SuccessMessages.specificationUpdated);
        } else {
          ToastFail(ErrorMessages.specificationUpdateFailed);
        }
      })
    } else {
      ToastFail(ErrorMessages.specificationUpdateFailed);
    }
  }).catch(() => {
    ToastFail(ErrorMessages.error);
    dispatch(startFormLoading());
  })
}

export const onUpdateSpecificationDone = (data) => dispatch => {
  dispatch({
    type: TYPES.SPECIFICATION_UPDATE_DONE,
    payload: data
  })
}

/*
  Created By: Sai Prasad
  Created Date: 12/10/2022
  Jira Ticket: JUN-3343
  Description: function to delete specification to item.
*/
export const onDeleteSpecification = (specificationId) => dispatch => {
  dispatch(startPRLoading());
  return client.deleteItemSpecifications(specificationId).then(response => {
    dispatch(stopPRLoading());
    if(response.status === 200) {
      response.json().then(responsejson => { 
        if(responsejson.statusCode === 200) {
          dispatch(onDeleteSpecificationDone(specificationId));
          ToastSuccess(SuccessMessages.specificationDeleted);
        } else {
          ToastFail(ErrorMessages.specificationDeleteFailed);
        }
      })
    } else {
      ToastFail(ErrorMessages.specificationDeleteFailed);
    }
  }).catch(() => {
    ToastFail(ErrorMessages.error);
    dispatch(stopPRLoading());
  })
}

export const onDeleteSpecificationDone = (specificationId) => dispatch => {
  dispatch({
    type: TYPES.SPECIFICATION_DELETE_DONE,
    payload: specificationId
  })
}

export const clearSpecifications = () => dispatch => {
  dispatch({
    type: TYPES.CLEAR_SPECIFICATIONS_DONE
  })
}